import { products } from "@/data/products"
import { faqs } from "@/components/FaqSection"

const SITE_URL = "https://www.clips-on.ch"
const LOGO_URL = "https://file.lumi.new/p427971759406342144/SPF2079575442590613504.png"

export function getOrganizationJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: "Clips'On",
    url: `${SITE_URL}/`,
    logo: LOGO_URL,
    email: "info@clips-on.ch",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Avenue de Champel 28",
      postalCode: "1206",
      addressLocality: "Genève",
      addressCountry: "CH",
    },
    sameAs: [
      "https://instagram.com/clipsonbutton",
      "https://pinterest.com/clipsonbuttons",
    ],
  }
}

export function getProductItemListJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: products.map((p, i) => {
      const item: Record<string, unknown> = {
        "@type": "Product",
        name: `Clips'On ${p.name}`,
        sku: p.ref,
        mpn: p.ref,
        brand: { "@type": "Brand", name: "Clips'On" },
        material: "Nylon 6/6",
        size: p.sizes.join(", "),
        offers: {
          "@type": "Offer",
          price: p.price,
          priceCurrency: "EUR",
          availability: p.soldOut
            ? "https://schema.org/OutOfStock"
            : "https://schema.org/InStock",
          itemCondition: "https://schema.org/NewCondition",
          url: `${SITE_URL}/#catalogue`,
        },
      }
      if (p.image) {
        item.image = p.image
      }
      return {
        "@type": "ListItem",
        position: i + 1,
        item,
      }
    }),
  }
}

export function getFaqJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(f => ({
      "@type": "Question",
      name: f.qFr,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.aFr,
      },
    })),
  }
}
